/**
 * useCheckout — Layer 3 mutation. Creates a Checkout Session and redirects the
 * browser to Stripe. ACCOUNT_PENDING (pre-approval publisher) → friendly toast.
 */
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { createCheckout } from "../api/billingApi";
import { toast } from "@/shared/lib/toast";
import { ErrorCode, getErrorCode } from "@/shared/lib/errorCodes";
import { setCheckoutCancelContext } from "@/shared/lib/checkoutCancel";
import type { CheckoutInput } from "../types";

export function useCheckout() {
  const { t } = useTranslation("pricing");
  return useMutation({
    mutationFn: (input: CheckoutInput) => createCheckout(input),
    onSuccess: (url) => {
      // Breadcrumb so the shared cancel page knows a plan checkout was abandoned.
      setCheckoutCancelContext("plan");
      window.location.assign(url);
    },
    onError: (err) => {
      toast.error(
        getErrorCode(err) === ErrorCode.ACCOUNT_PENDING
          ? t("checkout.errors.accountPending")
          : t("checkout.errors.generic"),
      );
    },
  });
}
